<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7.5C13.1 7.5 14 6.6 14 5.5C14 4.4 13.1 3.5 12 3.5C10.9 3.5 10 4.4 10 5.5C10 6.6 10.9 7.5 12 7.5ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM10 18.5C10 17.4 10.9 16.5 12 16.5C13.1 16.5 14 17.4 14 18.5C14 19.6 13.1 20.5 12 20.5C10.9 20.5 10 19.6 10 18.5Z" fill="currentColor"/>
    </svg>
</template>

<script>
  export default {};
</script>
